import SuggestNewOfferPage from 'components/pages/SuggestNewOffer';

const SuggestNewOffer = () => <SuggestNewOfferPage />;

export default SuggestNewOffer;
